import AdminLeftNav from "@src/features/app/left-nav/admin/AdminLeftNav";
import LoadingLeftNav from "@src/features/app/left-nav/LoadingLeftNav";
import TraineeLeftNav from "@src/features/app/left-nav/TraineeLeftNav";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";
import { useIsTrainee } from "@src/features/app/hooks/useIsTrainee";

const LeftNav: React.FC = () => {
  const { isTrainee, loading: isTraineeLoading } = useIsTrainee();
  const { loading: userActionPermissionsLoading } = useActionPermissions();
  if (isTraineeLoading || userActionPermissionsLoading)
    return <LoadingLeftNav />;
  if (isTrainee) return <TraineeLeftNav />;
  return <AdminLeftNav />;
};

export default LeftNav;
